export interface BugReporterConfig {
  app: string;
  apiKey: string;
  endpoint: string;
  shortcut: string;
  position: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  showButton: boolean;
  theme: 'light' | 'dark' | 'auto';
  locale: string;
  maxLogs: number;
  maxNetworkRequests: number;
  maskInputs: boolean;
  captureBody: boolean;
  beforeSubmit: ((payload: unknown) => unknown) | null;
  onSubmit: ((payload: unknown) => void) | null;
  metadata: Record<string, unknown>;
}

const defaults: BugReporterConfig = {
  app: '',
  apiKey: '',
  endpoint: 'https://bugs.bitterlemon.co/api/reports',
  shortcut: 'Ctrl+Shift+B',
  position: 'bottom-right',
  showButton: true,
  theme: 'dark',
  locale: 'en',
  maxLogs: 100,
  maxNetworkRequests: 50,
  maskInputs: true,
  captureBody: false,
  beforeSubmit: null,
  onSubmit: null,
  metadata: {},
};

let currentConfig: BugReporterConfig = { ...defaults };

export function setConfig(partial: Partial<BugReporterConfig>): void {
  currentConfig = { ...defaults, ...partial };
}

export function getConfig(): BugReporterConfig {
  return currentConfig;
}
